import type { Locale } from '../locales';

/**
 * Русское склонение по числу: 1 категория, 2 категории, 5 категорий.
 *
 * Правило одно на весь кабинет, потому что «3 КАТЕГОРИЙ» в шапке —
 * это не мелочь: подпись читают на каждом экране.
 */
export function plural(count: number, one: string, few: string, many: string): string {
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}

/** То же, но сразу с числом: «3 категории». */
export function withCount(count: number, one: string, few: string, many: string): string {
  return `${count} ${plural(count, one, few, many)}`;
}

/** Формы слова при числе — из словаря языка кабинета. */
export interface PluralForms {
  one: string;
  few: string;
  many: string;
}

/**
 * Склонение по числу на языке кабинета: в русском три формы, в английском
 * две, а в казахском существительное после числа не меняется («3 позиция»).
 */
export function pluralFor(locale: Locale, count: number, forms: PluralForms): string {
  if (locale === 'ru') return plural(count, forms.one, forms.few, forms.many);
  if (locale === 'en') return count === 1 ? forms.one : forms.many;

  return forms.one;
}
